var render = function render(){var _vm=this,_c=_vm._self._c;return _c('FormulateInput',{class:{
    fillspace: _vm.fillspace,
    'size-small': _vm.size == 'small',
    'size-medium': _vm.size == 'medium',
    'size-large': _vm.size == 'large'
  },attrs:{"type":_vm.type,"label":_vm.label,"input-class":_vm.inputClasses},on:{"click":_vm.emitClick}})
}
var staticRenderFns = []

export { render, staticRenderFns }